import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AlignRight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 4.5C14.2761 4.5 14.5 4.72386 14.5 5C14.5 5.27614 14.2761 5.5 14 5.5H3C2.72386 5.5 2.5 5.27614 2.5 5C2.5 4.72386 2.72386 4.5 3 4.5H14ZM14.5 8.5C14.5 8.22386 14.2761 8 14 8H3C2.72386 8 2.5 8.22386 2.5 8.5C2.5 8.77614 2.72386 9 3 9H14C14.2761 9 14.5 8.77614 14.5 8.5ZM14.5 12C14.5 11.7239 14.2761 11.5 14 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5H14C14.2761 12.5 14.5 12.2761 14.5 12Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AlignRight
